import { useEffect, useState } from 'react';
import { motion, animate } from 'framer-motion';
import { EASE } from './motion';
import { Logo } from './Logo';

export const Preloader = ({ onDone }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const controls = animate(0, 100, {
      duration: 1.4,
      ease: 'easeInOut',
      onUpdate: (v) => setCount(Math.round(v)),
    });
    const t = setTimeout(onDone, 1750);
    return () => {
      controls.stop();
      clearTimeout(t);
    };
  }, [onDone]);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center"
      exit={{ y: '-100%' }}
      transition={{ duration: 0.7, ease: EASE }}
    >
      <div className="flex items-center gap-4">
        <span className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: '115%' }}
            animate={{ y: 0 }}
            transition={{ duration: 0.7, delay: 0.2, ease: EASE }}
          >
            <Logo className="h-16 sm:h-20" />
          </motion.span>
        </span>
      </div>
      <div className="absolute bottom-12 left-6 right-6 sm:left-12 sm:right-12 h-px bg-ink/10">
        <motion.div
          className="h-px bg-accent"
          initial={{ width: '0%' }}
          animate={{ width: '100%' }}
          transition={{ duration: 1.4, ease: 'easeInOut' }}
        />
      </div>
      <span className="absolute bottom-6 right-6 sm:right-12 font-display text-sm text-brand tabular-nums">
        {count}%
      </span>
    </motion.div>
  );
};
